import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import classNames from 'classnames';
import { FeatureListContext } from '../FeatureList.Context/FeatureList.Context.es.js';
import { FeatureListIcon } from '../FeatureList.Icon/FeatureList.Icon.es.js';

const FeatureListItem = ({ icon, heading, className, children })=>{
    const { direction } = useContext(FeatureListContext);
    return jsxs("div", {
        className: classNames('fl-item', direction, className),
        "data-testid": "feature-list-item",
        children: [
            jsx(FeatureListIcon, {
                name: icon
            }),
            jsxs("div", {
                children: [
                    jsx("dt", {
                        className: "fl-dt",
                        children: heading
                    }),
                    jsx("dd", {
                        className: "fl-dd",
                        children: children
                    })
                ]
            })
        ]
    });
};
FeatureListItem.displayName = 'FeatureList.Item';

export { FeatureListItem };
//# sourceMappingURL=FeatureList.Item.es.js.map
